module.exports = __webpack_public_path__ + "static/media/service-deactivated.ac70c8bd.jpg";